/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'link-arrow': {
    width: 32,
    height: 20,
    viewBox: '0 0 32 20',
    data: '<path pid="0" d="M24.381 0c.748 0 1.37.544 1.5 1.262l.024.276-.001 13.209 3.495-3.527a1.513 1.513 0 011.944-.178l.21.178a1.55 1.55 0 01.177 1.962l-.176.214-6.096 6.153-.102.095-.136.102-.118.071-.125.061-.122.046-.137.038-.068.014-.135.018-.134.006-.091-.003-.12-.012-.157-.03-.143-.044-.152-.064-.1-.053-.104-.067a1.57 1.57 0 01-.21-.178l-6.096-6.153a1.549 1.549 0 010-2.176 1.513 1.513 0 011.944-.178l.211.178 3.494 3.528V3.077H1.524c-.748 0-1.37-.544-1.5-1.262L0 1.538C0 .783.539.155 1.25.025L1.524 0H24.38z" _fill="#000" fill-rule="nonzero"/>'
  }
})
